import { memo } from "react";
import CourseBanner from "./courses/courseBanner";

const CARD_KEYS = ["c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8"];

const FilterSkeleton = () => (
  <div className="col-12 col-sm-4 my-3">
    <span
      className="placeholder d-block mb-2"
      style={{ width: 90, height: 14, borderRadius: 4 }}
      aria-hidden="true"
    />
    <span
      className="placeholder d-block w-100"
      style={{ height: 38, borderRadius: 6 }}
      aria-hidden="true"
    />
  </div>
);

const CardSkeleton = () => (
  <div className="col-12 col-sm-6 col-md-4 my-3 col-lg-3">
    <div className="card border-0 shadow br-10px h-100">
      <span
        className="placeholder d-block w-100"
        style={{ aspectRatio: "16 / 9", borderRadius: 10 }}
        aria-hidden="true"
      />
      <div className="p-3">
        <span
          className="placeholder d-block col-9 mb-2"
          style={{ height: 16, borderRadius: 4 }}
          aria-hidden="true"
        />
        <span
          className="placeholder d-block col-6"
          style={{ height: 12, borderRadius: 4 }}
          aria-hidden="true"
        />
      </div>
    </div>
  </div>
);

/**
 * Loading skeleton for the Courses screen — mirrors the real layout (banner,
 * filter dropdowns and the course-card grid) so there is no layout shift once
 * data arrives. Uses Bootstrap's `placeholder` utilities.
 */
const CoursesSkeleton = () => (
  <>
    <CourseBanner
      heading="Courses"
      desc="Get these courses for FREE & Learn something new today"
    />
    <div
      className="w-100 my-5 placeholder-glow"
      role="status"
      aria-label="Loading"
    >
      <div className="container-xxl">
        <div className="row">
          <div className="col-12">
            <h3>Search Video lectures</h3>
          </div>
          <FilterSkeleton />
          <FilterSkeleton />
        </div>

        <div className="row my-4">
          {CARD_KEYS.map((key) => (
            <CardSkeleton key={key} />
          ))}
        </div>
      </div>
      <span className="visually-hidden">Loading…</span>
    </div>
  </>
);

export default memo(CoursesSkeleton);
